import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TableRowContext = /*#__PURE__*/createContext(undefined);
export default function TableRowProvider({
  children,
  row,
  tdProps
}) {
  const value = useMemo(() => ({
    row,
    tdProps
  }), [row, tdProps]);
  return /*#__PURE__*/_jsx(TableRowContext.Provider, {
    value: value,
    children: children
  });
}
export function useTableRow() {
  const context = useContext(TableRowContext);
  if (context === undefined) {
    throw new Error('useTableRow must be used within a TableRowProvider');
  }
  return context;
}